import type { FormRow } from 'src/generated-types/form-field'

/**
 * Parses stored form-schema layout JSON for preview use.
 *
 * @returns Parsed rows when `layoutJson` is a non-empty string that parses to a
 *   non-empty `FormRow[]`; otherwise `null` (missing, invalid JSON, wrong shape, or empty array).
 */
export function parseFormSchemaLayoutForPreview(layoutJson: string | undefined): FormRow[] | null {
  if (!layoutJson || typeof layoutJson !== 'string') {
    return null
  }
  try {
    const parsed = JSON.parse(layoutJson) as unknown
    if (!Array.isArray(parsed) || parsed.length === 0) {
      return null
    }
    return parsed as FormRow[]
  } catch {
    return null
  }
}
